import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { GoogleMapUrl } from '@bd/bdcore-utilities';
// import { FavoriteToggle, FavoriteEdit } from '../../../components/Favorites';
// import { colors } from '../../styles';
import icons from '../../../components/IconsList';

const styles = css`
  .CommunityAddress_mobilePin {
    width: 20px;
    height: 26px;
    @media(min-width: 992px) {
      width: 28px;
      height: 38px;
    }
    span {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        background-image: url(${icons.mapPin});
        background-position: center;
        background-repeat: no-repeat;
        background-size: 17px 23px;
        width: 17px;
        height: 23px;
        @media(min-width: 992px) {
          background-size: 26px 35px;
          width: 26px;
          height: 35px;
        }
      }
    }
  }
  .CommunityAddress_h1 {
    font-weight: 300;
    font-size: 26px;
    color: #000000;
    letter-spacing: -0.62px;
    margin: 0;
    @media(min-width: 992px) {
      font-size: 42px;
      letter-spacing: -1px;
    }
  }
  .CommunityAddress_address {
    font-weight: 700;
    font-size: 14px;
    color: #000000;
    letter-spacing: 1.17px;
    text-transform: uppercase;
    @media(min-width: 992px) {
      font-size: 20px;
      letter-spacing: 1.67px;
    }
  }
  .CommunityAddress_addressWrapper {
    position: relative;
    padding: 0 0 12px;
    margin: 0 0 12px;
    @media(min-width: 992px) {
      padding: 0 0 15px;
      margin: 0 0 22px;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #DADADA;
      width: 100%;
      height: 1px;
      @media(min-width: 992px) {
        width: 75px;
      }
    }
    &::before {
      @media(min-width: 992px) {
        content: '';
        position: absolute;
        left: 0;
        bottom: -6px;
        background-color: #DADADA;
        width: 100%;
        height: 1px;
        width: 75px;
      }
    }
  }
  .CommunityAddress_link {
    font-weight: 700;
    font-size: 13px;
    color: #171717;
    letter-spacing: 0;
    line-height: 25px;
    @media(min-width: 992px) {
      font-size: 16px;
    }
  }

  /* Favorite Styling */

  .FavoriteEditWrap {
    padding:4px;
    text-align: left;
    textarea {
      background:#333;
      border:1px solid black;
      border-radius: 0;
      margin-bottom:4px;
      width:100%;
      height:50px;
      color: #FFFFFF;
    }
  }

  .DetailFavorites_wrapper {
    display: flex;
    max-width: 170px;
    margin: 15px 0;
    padding: 8px 10px;
    background-color: #d69a2a !important;
    .FavoriteToggle {
      background-image: url(/images/icons/favorites-heart-outline.svg);
      background-repeat: no-repeat;
      background-position: left center;
      background-size: cover;
      width: 30px;
      height: 30px;
      transition: all .25s ease;
      display: flex;
      justify-content: flex-start;
      margin: 0 5px;
    }
    .FavoriteToggle-active {
      background-image: url(/images/icons/favorites-heart-full.svg);
    }
    .ToggleText {
      text-transform: uppercase;
      color: #FFFFFF;
      font-weight: bold;
      font-size: 16px;
      line-height: 21px;
      letter-spacing: 1px;
      padding: 2px 0px 0px 40px;
      cursor: pointer;
      @media(min-width: 992px) {
        font-size: 16px;
        line-height: 25px;
        letter-spacing: 2px
        padding: 2px 0px 0px 40px;
      }
    }
  }

`;

function CommunityAddress({ community, className }) {
  return (
    <div className={`${className} ${styles}`}>
      <div className="d-flex">
        <hgroup className="d-flex flex-column flex-fill CommunityAddress_addressWrapper">
          <h1 className="CommunityAddress_h1">{get(community, 'name')}</h1>
          <h2 className="CommunityAddress_address">{get(community, 'address.streetAddress')} {get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}</h2>
        </hgroup>
        <a href={GoogleMapUrl(community)} className="CommunityAddress_mobilePin pr-lg-2 pr-xl-5" target="_blank" rel="noopener noreferrer"><span /></a>
      </div>
      <div className="CommunityAddress_contact mb-5">
        <h4>Contact Our Office</h4>
        <ul className="list-unstyled">
          {
            get(community, 'hours') &&
            <li><b>Hours: </b>{get(community, 'hours')}</li>
          }
          {
            get(community, 'outOfCommunity.address.streetAddress') &&
            <li><b>Office: </b>{get(community, 'outOfCommunity.address.streetAddress')}</li>
          }
          {
            get(community, 'telephone') &&
            <li><b>Call: </b>{get(community, 'telephone')}</li>
          }
        </ul>
      </div>
      {/* <div className="DetailFavorites_wrapper">
        <FavoriteToggle community={community} className="DetailFavorites_toggle">
          <span className="ToggleText">Favorite</span>
        </FavoriteToggle>
      </div> */}
      {/* {
        favorite &&
        <div className="FavoriteEditWrap">
          <FavoriteEdit favorite={favorite} />
        </div>
      } */}
    </div>
  );
}

CommunityAddress.propTypes = {
  community: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  // favorite: PropTypes.object,
};

CommunityAddress.defaultProps = {
  favorite: undefined,
};


export default CommunityAddress;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityDetails/CommunityAddress.js